import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { ThemeProvider, useTheme } from "@/contexts/ThemeContext";
import EditorialGridLayout from "@/components/editorial/EditorialGridLayout";
import GridLinesWrapper from "@/components/editorial/GridLinesWrapper";
import { Home } from "lucide-react";

const NotFoundContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { theme } = useTheme();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  const headingColor = theme === 'dark' ? '#FFFFFF' : '#111111';
  const textColor = theme === 'dark' ? '#AAAAAA' : '#555555';

  return (
    <EditorialGridLayout>
      <GridLinesWrapper>
        <section className="min-h-screen flex items-center justify-center transition-colors duration-300">
          <div className="max-w-3xl mx-auto px-8 text-center">
            {/* 404 Heading */}
            <h1 
              className="text-3xl lg:text-4xl font-bold leading-[1.1] tracking-tight mb-4 transition-colors duration-300"
              style={{ color: headingColor }}
            >
              404
            </h1>
            
            {/* Subheading */}
            <h2 
              className="text-xl sm:text-2xl lg:text-3xl font-bold leading-[1.1] tracking-tight mb-6 transition-colors duration-300"
              style={{ color: headingColor }}
            >
              Page Not Found
            </h2>
            
            {/* Description */}
            <p 
              className="text-sm leading-relaxed max-w-lg mx-auto mb-8 transition-colors duration-300" 
              style={{ color: textColor }}
            >
              Fiddlesticks, I know I put that page around here somewhere...
            </p>
            <p 
              className="text-sm leading-relaxed max-w-lg mx-auto mb-8 transition-colors duration-300" 
              style={{ color: textColor }}
            >
              The page you're looking for doesn't exist or has been moved.
            </p>
            
            {/* CTA Button */}
            <div className="flex items-center justify-center">
              <button 
                onClick={() => navigate('/')}
                className="w-[160px] px-4 py-2 bg-black text-white text-sm font-medium hover:bg-[#333333] transition-all flex items-center justify-center gap-2 rounded-lg"
              >
                <Home className="w-3 h-3" />
                Return Home
              </button>
            </div>
          </div>
        </section>
      </GridLinesWrapper>
    </EditorialGridLayout>
  );
};

const NotFound = () => {
  return (
    <ThemeProvider>
      <NotFoundContent />
    </ThemeProvider>
  );
};

export default NotFound;
